import * as React from 'react';
import { clsx } from 'clsx';

import * as styles from './Advantage.css';

type IType = 'time' | 'reliability' | 'wishes' | 'price';

export const Advantage = ({ title, description, type }: { title: string; description: string; type: IType }) => {
  return (
    <div className={styles['advantage']}>
      <div className={clsx(styles['icon'], styles[type])}></div>
      <div className={styles['content']}>
        <div className={styles['title']}>{title}</div>
        <div className={styles['description']}>{description}</div>
      </div>
    </div>
  );
};
